
import * as React from 'react';
import { fluentSvgIconStyles } from '../../../../styles/iconStyles';

export const StarOff20Regular: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return <svg role="img" focusable="false" aria-hidden viewBox="0 0 20 20" width={20} height={20} fill="currentColor" className={props.className} style={{ ...props.style, ...fluentSvgIconStyles }} onClick={props.onClick}>
        <path
            d="M2.86 2.15a.5.5 0 1 0-.71.7l4.1 4.1-3.4.49a1 1 0 0 0-.55 1.7l3.13 3.05-.74 4.3a1 1 0 0 0 1.45 1.05L10 15.51l3.86 2.03a1 1 0 0 0 1.45-1.05l-.1-.57 1.94 1.93a.5.5 0 0 0 .7-.7l-15-15ZM13.99 14.7l.34 1.96-3.86-2.03a1 1 0 0 0-.93 0l-3.87 2.03.74-4.3a1 1 0 0 0-.29-.89L3 8.43l4.12-.6L14 14.7Zm-.11-3.23a1 1 0 0 0-.13.16l.88.88-.05-.32 3.12-3.05a1 1 0 0 0-.56-1.7l-4.31-.63L10.9 2.9a1 1 0 0 0-1.8 0L7.76 5.63l.74.75L10 3.34l1.93 3.91c.15.3.43.5.75.55l4.32.63-3.12 3.04Z"
            fill="currentColor"
        />
    </svg>
}